export default "__VITE_ASSET__CSCdElyb__"